/**
 * Energy Label Modal Handler
 * Handles opening/closing of energy label modals and image display
 */

class EnergyLabelHandler {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Find all energy label buttons
    const energyLabelButtons = document.querySelectorAll('[data-energy-label] button[data-energy-label-opener]');
    
    energyLabelButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.handleLabelClick(button);
      });
    });

    // Handle dynamic content (e.g., AJAX-loaded product cards)
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const newButtons = node.querySelectorAll ? node.querySelectorAll('[data-energy-label] button[data-energy-label-opener]') : [];
            newButtons.forEach((button) => {
              if (!button.dataset.listenerAttached) {
                button.dataset.listenerAttached = 'true';
                button.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.handleLabelClick(button);
                });
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  handleLabelClick(button) {
    const imageUrl = button.dataset.imageUrl;
    if (!imageUrl) {
      console.warn('Energy label: No image URL found');
      return;
    }

    // Get the global modal
    const modal = document.getElementById('energy-label-modal-global');
    if (!modal) {
      console.warn('Energy label: Global modal not found');
      return;
    }

    // Update the modal image before opening
    const modalImage = modal.querySelector('.energy-label-modal__image');
    if (modalImage) {
      modalImage.src = imageUrl;
      // Also update srcset if needed (for responsive images)
      modalImage.srcset = '';
      
      // Update width and height when image loads to maintain aspect ratio
      modalImage.onload = function() {
        if (this.naturalWidth && this.naturalHeight) {
          this.width = this.naturalWidth;
          this.height = this.naturalHeight;
        }
      };
    }

    // Use the modal-dialog custom element's open method if available
    if (modal.tagName === 'MODAL-DIALOG' && typeof modal.open === 'function') {
      modal.open(button);
    } else {
      // Fallback: manually open modal
      this.openModal(modal, button);
    }
  }

  openModal(modal, opener) {
    modal.classList.remove('invisible');
    modal.setAttribute('open', '');
    
    // Focus trap
    const focusableElements = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusableElements.length > 0) {
      focusableElements[0].focus();
    }

    // Close on escape key
    const escapeHandler = (e) => {
      if (e.key === 'Escape') {
        this.closeModal(modal);
        document.removeEventListener('keydown', escapeHandler);
      }
    };
    document.addEventListener('keydown', escapeHandler);

    // Store handler for cleanup
    modal.dataset.escapeHandler = 'true';
  }

  closeModal(modal) {
    modal.classList.add('invisible');
    modal.removeAttribute('open');
  }
}

// Initialize on page load
if (typeof window !== 'undefined') {
  window.energyLabelHandler = new EnergyLabelHandler();
}

